import React from 'react';
import { Col, Row, Typography, Tag } from 'antd';
import { useSelector } from 'react-redux';
import { ShoppingCartOutlined, FileAddOutlined } from '@ant-design/icons';
import MetricCard from '../../components/MetricCard';
import { formatCurrency } from '../../utils/formatters';

const { Title, Text } = Typography;

const Dashboard = () => {
  const { user } = useSelector((state) => state.auth);
  const { orders } = useSelector((state) => state.orders);
  const { shops } = useSelector((state) => state.shops);

  const myOrders = orders.filter(o => o.bdeId === user.id);
  const totalOrders = myOrders.length;
  const totalEarnings = myOrders
    .filter(o => !o.commissionPaid && ['Expected', 'Processing', 'Completed'].includes(o.status))
    .reduce((sum, order) => sum + ((Number(order.amount) * 0.10) || 0), 0);

  // Count of orders where commission is not paid (New Orders)
  const newOrdersCount = myOrders.filter(o => !o.commissionPaid).length;

  const onboardedShopsCount = shops.filter(s => s.bdeId === user.id).length;

  return (
    <div style={{ paddingBottom: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 32, flexWrap: 'wrap', gap: 16 }}>
        <div>
          <Title level={2} style={{ margin: 0 }}>BDE Dashboard</Title>
          <Text type="secondary">Track your sales performance.</Text>
        </div>
        <div style={{ display: 'flex', gap: 12 }}>
          <Tag color="blue" style={{ padding: '4px 12px', fontSize: 14 }}>{new Date().toLocaleDateString()}</Tag>
        </div>
      </div>

      <Row gutter={[24, 24]}>
        <Col xs={24} sm={8}>
          <MetricCard
            title="My Total Orders"
            value={totalOrders}
            prefix={<ShoppingCartOutlined />}
            color="#1890ff"
            trend={5.4}
          />
        </Col>
        <Col xs={24} sm={8}>
          <MetricCard
            title="New Orders"
            value={newOrdersCount}
            prefix={<FileAddOutlined />}
            color="#faad14"
            trend={0}
          />
        </Col>
        <Col xs={24} sm={8}>
          <MetricCard
            title="My Pending Commission"
            value={formatCurrency(totalEarnings)}
            prefix={<span style={{ fontWeight: 'bold' }}>₹</span>}
            color="#3f8600"
            trend={12.1}
          />
        </Col>
        <Col xs={24} sm={8}>
          <MetricCard
            title="Onboarded Shops"
            value={onboardedShopsCount}
            prefix={<FileAddOutlined />}
            color="#0ea5e9"
            trend={0}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
